import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 lg:pt-40 lg:pb-24 border-b-2 border-black" data-id="element-61">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-62">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-63">
          <div className="lg:col-span-9" data-id="element-64">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-65">
              <div className="inline-block border-2 border-black px-4 py-2 mb-8 bg-white" data-id="element-66">
                <span className="text-sm font-bold uppercase tracking-widest" data-id="element-67">
                  Досвід роботи у ЗСУ — 6 років
                </span>
              </div>

              <h1 className="text-6xl sm:text-7xl lg:text-[110px] font-bold leading-[0.9] tracking-tight mb-8" data-id="element-68">
                ЗАХИСТ ПРАВ <br data-id="element-69" />
                ВІЙСЬКОВИХ
              </h1>
            </motion.div>
          </div>

          <div className="lg:col-span-3 flex flex-col justify-end" data-id="element-70">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} data-id="element-71">
              <p className="text-lg font-medium leading-relaxed mb-8" data-id="element-72">
                Професійний юридичний супровід: відстрочка, ВЛК, СЗЧ, виплати та
                звільнення. Безкоштовна перша консультація.
              </p>

              <a href="#contact" className="flex items-center justify-between w-full px-6 py-4 bg-black hover:bg-white hover:text-black text-white border-2 border-black transition-colors text-sm font-bold uppercase tracking-widest" data-id="element-73">
                Отримати консультацію
                <ArrowRight className="w-5 h-5" data-id="element-74" />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}